import React from 'react';
import { isFragment } from 'react-is';

export default function flattenFragment(children) {
  return React.Children.toArray(children).reduce(function(array, element) {
    return isFragment(element)
      ? [...array, element.props.children]
      : [...array, element];
  }, []);
}
